module.exports = __webpack_public_path__ + "static/media/err404.198f64f5.svg";